import EnlilAxiosRestAPI from "../../../../util/EnlilAxiosRestAPI";
import EnterpriseComponent from "../../EnterpriseComponent";
import {V1AdminOrganizationPositionIDOCToArray, V1AdminPositionIDOCToArray} from "../../../../util/Payload";
import {v4 as uuidv4} from "uuid";

class AdminOrganizationPositionEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let idocResponse = this.getIDOCResponse() ?? "v1.AdminOrganization-002";

        let qbe = btoa(JSON.stringify({
            "ShifamedMessage": {
                "-idoc": "v1.AdminOrganization-002",
                "-id": uuidv4(),
                "AdminOrganization": {
                    "_attributes": {
                        "limit": 1,
                        "sort": null,
                        "offset": 0
                    },
                    "QueryGroups": {
                        "QueryGroup": [
                            {
                                "Name": "QG1",
                                "Type": "QueryGroup",
                                "Operator": "AND",
                                "Membership": {
                                    "Member": [
                                        {
                                            "Type": "Attribute",
                                            "Name": "USID",
                                            "Value": foreignKey,
                                            "Operator": "EQUAL"
                                        }
                                    ]
                                }
                            }
                        ]
                    },
                    "AdminPosition": {
                        "_attributes": {
                            "limit": pageSize,
                            "sort": this.getFormattedSortSpecification(),
                            "offset": (page - 1) * pageSize
                        }
                    }
                }
            }
        }))

        EnlilAxiosRestAPI({
            method: "GET",
            url: "t3/v1/admin_organizations",
            json: true,
            params: {
                "QBE": qbe
            },
            headers: {
                "idoc-response": idocResponse,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1AdminOrganizationPositionIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

    enterpriseComponentPostIDOC = () => {
        let payload = {};

        let adminOrganization = {};

        adminOrganization["USID"] = this.getEnterpriseObject().getEnterpriseComponent("AdminOrganization").getAttributeValue("USID");
        adminOrganization["AdminPosition"] = {
            "USID": this.getAttributeValue("USID"),
            "Name": this.getAttributeValue("Name"),
            "OrganizationUSID": this.getEnterpriseObject().getEnterpriseComponent("AdminOrganization").getAttributeValue("USID"),
            "ParentUSID": this.getAttributeValue("ParentUSID"),
            "PrimaryEmployeeUSID": this.getAttributeValue("PrimaryEmployeeUSID"),
        }

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.AdminOrganization-002";
        payload.ShifamedMessage.AdminOrganization = adminOrganization;

        return payload;
    };

    performInsert() {
        let payload = this.enterpriseComponentPostIDOC();

        let options = {
            method: "PUT",
            url: "t3/v1/admin_organizations",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.AdminOrganization-002",
                "idoc-response": "v1.AdminOrganization-002"
            },
        };
        this.notifyInsertStartListeners();
        EnlilAxiosRestAPI(options)
            .then(response => {
                this.insertEnterpriseComponentSuccess(V1AdminOrganizationPositionIDOCToArray(response.data));
            })
            .catch(error => {
                this.insertEnterpriseComponentFailed(error);
            });
    };

    enterpriseComponentPutIDOC = () => {
        let payload = {};

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.AdminPosition-001";
        payload.ShifamedMessage.AdminPosition = this.preparePUTPayload();

        return payload;
    };

    performUpdate() {
        let payload = this.enterpriseComponentPutIDOC();

        let options = {
            method: "PUT",
            url: "t3/v1/admin_positions",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.AdminPosition-001",
                "idoc-response": "v1.AdminPosition-001",
            },
        };
        this.notifyUpdateStartListeners();
        EnlilAxiosRestAPI(options)
            .then(response => {
                this.updateEnterpriseComponentSuccess(V1AdminPositionIDOCToArray(response.data));
            })
            .catch(error => {
                this.updateEnterpriseComponentFailed(error);
            });
    };

}

export default AdminOrganizationPositionEnterpriseComponent;